import { requestDialog } from './requestDialog';
import type { EventUsageRestrictionWarningDialogRequest } from './usageRestrictionWarningDialogRequest';

export function showEventUsageRestrictionWarningDialog(req: EventUsageRestrictionWarningDialogRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/EventUsageRestrictionWarningDialog.vue'));
}
